var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu-dash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.491,
    height: 28.491,
    viewBox: "0 0 28.491 28.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_850",
    "data-name": "Grupo 850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1420",
    "data-name": "Caminho 1420",
    d: "M11.278,9.5h-9.5A1.783,1.783,0,0,1,0,7.716V1.781A1.783,1.783,0,0,1,1.781,0h9.5a1.783,1.783,0,0,1,1.781,1.781V7.716A1.783,1.783,0,0,1,11.278,9.5Zm-9.5-8.31a.6.6,0,0,0-.594.594V7.716a.6.6,0,0,0,.594.594h9.5a.6.6,0,0,0,.594-.594V1.781a.6.6,0,0,0-.594-.594Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_851",
    "data-name": "Grupo 851",
    transform: "translate(0 11.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1421",
    "data-name": "Caminho 1421",
    d: "M11.278,26.62h-9.5A1.783,1.783,0,0,1,0,24.839V11.781A1.783,1.783,0,0,1,1.781,10h9.5a1.783,1.783,0,0,1,1.781,1.781V24.839A1.783,1.783,0,0,1,11.278,26.62Zm-9.5-15.433a.6.6,0,0,0-.594.594V24.839a.6.6,0,0,0,.594.594h9.5a.6.6,0,0,0,.594-.594V11.781a.6.6,0,0,0-.594-.594Z",
    transform: "translate(0 -10)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_852",
    "data-name": "Grupo 852",
    transform: "translate(15.433 18.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1422",
    "data-name": "Caminho 1422",
    d: "M24.278,25.5h-9.5A1.783,1.783,0,0,1,13,23.716V17.781A1.783,1.783,0,0,1,14.781,16h9.5a1.783,1.783,0,0,1,1.781,1.781v5.936A1.783,1.783,0,0,1,24.278,25.5Zm-9.5-8.31a.6.6,0,0,0-.594.594v5.936a.6.6,0,0,0,.594.594h9.5a.6.6,0,0,0,.594-.594V17.781a.6.6,0,0,0-.594-.594Z",
    transform: "translate(-13 -16)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_853",
    "data-name": "Grupo 853",
    transform: "translate(15.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1423",
    "data-name": "Caminho 1423",
    d: "M24.278,16.62h-9.5A1.783,1.783,0,0,1,13,14.839V1.781A1.783,1.783,0,0,1,14.781,0h9.5a1.783,1.783,0,0,1,1.781,1.781V14.839A1.783,1.783,0,0,1,24.278,16.62Zm-9.5-15.433a.6.6,0,0,0-.594.594V14.839a.6.6,0,0,0,.594.594h9.5a.6.6,0,0,0,.594-.594V1.781a.6.6,0,0,0-.594-.594Z",
    transform: "translate(-13)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDash);
export default __webpack_public_path__ + "static/media/menu-dash.f497b1c577266c52711385a0d21f1da9.svg";
export { ForwardRef as ReactComponent };